export default __webpack_public_path__ + "static/media/organisation-icon.ade9fee1.svg";